module.exports = __webpack_public_path__ + "img/brain.a3978d72.svg";